import { CSSObject } from '@emotion/react'
import { GemColors, Spacing, ZIndex } from '@opallabs/gem'

export const expandEditorToggle = (isFullScreen: boolean): CSSObject => ({
  left: isFullScreen ? 'min(6px, 6px)' : 'min(484px, 50%)',
  position: 'fixed',
  top: 'calc(50vh - 65px)',
  transition: 'left 0.3s ease-in-out',
  zIndex: ZIndex.Shroud.Popover,
})

export const expandEditorButton: CSSObject = {
  boxShadow: '0 0 8px rgba(0, 0, 0, 0.16)',
  padding: 4,
}

export const expandEditorIcon = (isFullScreen: boolean): CSSObject => ({
  transform: !isFullScreen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.3s ease-in-out',
})

export const editorStyleOverrides = (isExpanded: boolean): CSSObject => ({
  '.CollaborationTextEditor': {
    border: 'none',
    borderRadius: 0,
    insetBlockEnd: Spacing.XS * 15,
    insetInlineStart: isExpanded
      ? Spacing.XS * 3
      : `min(${Spacing.XL * 10}px, 50%)`,
    marginInlineEnd: 0,
    position: 'fixed',
    insetInlineEnd: 0,
    insetBlockStart: Spacing.XS * 16 + 1,
    // `z-index: 5` is one below the shroud notifications z-index
    zIndex: isExpanded ? ZIndex.Element.Level5 : 0,
    // The `z-index` should transition after `inset-inline-start` finishes
    // transitioning. When changing the transition duration for
    // `inset-inline-start`, change the `z-index` delay to the same duration
    transition: 'inset-inline-start 275ms ease-in-out, z-index 0s',
    // Only delay when the post sidebar is re-opening
    // It's counterintuitive, but the value is added
    // immediately when the post shroud is to be toggled open
    transitionDelay: !isExpanded ? '0s, 275ms' : undefined,
  },

  '.CollaborationTextEditorContent': {
    alignSelf: 'center',
    display: 'inline-grid',
    justifyContent: 'center',
    paddingBlockEnd: '30vh',
    width: '100%',
    '& > .tiptap': {
      minWidth: 680,
    },
    '& > :where(:not(.react-renderer, .tableWrapper))': {
      maxWidth: 680,
      paddingBlockStart: 60,
    },
    '.selection': {
      backgroundColor: GemColors.B450,
      color: GemColors.N000,
    },
  },

  '.CollaborationTextEditorControlBar': {
    backgroundColor: GemColors.N050,
    borderRadius: 0,
    cursor: 'default',
    justifyContent: 'center',
  },

  '.LastSavedTime': {
    position: 'absolute',
    right: 0,
  },
})
